<template>
  <div>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12">
          <gg-card>
            <gg-card-header>
              Migration Instructions &amp; Details
            </gg-card-header>
            <gg-card-text>
              <v-row>
                <v-col cols="12">
                  <p>
                    Now we need some information about your previous provider. Answer as accurately
                    as possible to expedite your request.
                  </p>
                  <p>
                    Don't know everything? No problem! Just tell us what you can, and we will be in touch if we have any
                    questions.
                  </p>
                  <p>
                    In most cases it is ideal to provide us with your primary control panel or account management
                    login. This will usually give us everything we need to complete your migration. You can provide
                    us with your FTP information instead if you are just transferring a website. Use the
                    Additional Instructions field to supply additional login information and/or other instructions for us.
                  </p>
                  <p>
                    More information about migrating to GreenGeeks is available in our
                    <a href="https://www.greengeeks.com/kb/2498/greengeeks-migration-policy/" target="_blank">
                      Migration Policy
                    </a>.
                  </p>
                </v-col>
              </v-row>
            </gg-card-text>
          </gg-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <gg-card>
            <gg-card-text>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <gg-text-field
                        outlined
                        label="Previous Hosting Provider"
                        v-model="previous_provider"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <gg-text-field
                        outlined
                        label="Control Panel URL"
                        v-model="cp_url"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <gg-select
                        outlined
                        label="Control Panel Type"
                        v-model="cp_type"
                        :items="cp_items"
                        item-text="name"
                        item-value="value"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <gg-text-field
                        outlined
                        label="FTP Hostname"
                        v-model="hostname"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <gg-text-field
                        outlined
                        label="Control Panel/FTP Username"
                        v-model="username"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <gg-text-field
                        outlined
                        label="Control Panel/FTP Password"
                        v-model="password"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        label="Additional Instructions or Comments (for example: additional login information, steps to login, etc)"
                        dense
                        outlined
                        class="gg-input"
                        v-model="notes"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <gg-error :data="this.errors.all()"/>
                  </v-row>
                </v-container>
              </v-form>
            </gg-card-text>
          </gg-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="text-center">
          <gg-btn secondary @click="setStep(1)">
            Back
          </gg-btn>
          <gg-btn color="primary" class="mx-1" :loading="loading" @click="submit">
            Submit Migration Request
          </gg-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Migration',
  props: {
    loading: {
      type: Boolean,
    }
  },
  data: () => ({
    cp_items: [
      {
        name: 'cPanel/WHM',
        value: 'cPanel'
      },
      {
        name: 'Plesk',
        value: 'Plesk'
      },
      {
        name: 'Helm',
        value: 'Helm'
      },
      {
        name: 'Unsure',
        value: 'Unsure'
      }
    ],
  }),
  computed: {
    ...mapGetters({
      migration: 'wizard_model/migration'
    }),
    previous_provider: {
      get () {
        return this.migration.previous_provider
      },
      set (val) {
        this.setProvider(val)
      }
    },
    cp_url: {
      get () {
        return this.migration.cp_url
      },
      set (val) {
        this.setUrl(val)
      }
    },
    cp_type: {
      get () {
        return this.migration.cp_type
      },
      set (val) {
        this.setType(val)
      }
    },
    hostname: {
      get () {
        return this.migration.hostname
      },
      set (val) {
        this.setHostname(val)
      }
    },
    username: {
      get () {
        return this.migration.username
      },
      set (val) {
        this.setUsername(val)
      }
    },
    password: {
      get () {
        return this.migration.password
      },
      set (val) {
        this.setPassword(val)
      }
    },
    notes: {
      get () {
        return this.migration.notes
      },
      set (val) {
        this.setNotes(val)
      }
    },
  },
  methods: {
    ...mapMutations({
      setStep: 'wizard/SET_STEP',
      setProvider: 'wizard_model/SET_MIGRATION_PREVIOUS_PROVIDER',
      setUrl: 'wizard_model/SET_MIGRATION_CP_URL',
      setType: 'wizard_model/SET_MIGRATION_CP_TYPE',
      setHostname: 'wizard_model/SET_MIGRATION_HOSTNAME',
      setUsername: 'wizard_model/SET_MIGRATION_USERNAME',
      setPassword: 'wizard_model/SET_MIGRATION_PASSWORD',
      setNotes: 'wizard_model/SET_MIGRATION_NOTES'
    }),
    ...mapActions(['reportError', 'reportSuccess']),
    async submit () {
      this.$emit('submit')
    },
  },
}
</script>
